<template>
    <form-container :headerText="title" :width="480" action="editMeisterschaftTeam"
                    :valid-actions="['editMeisterschaftTeam']" @save="save()">
        <div v-if="rules && team" class="px-7 pb-3">
            <v-radio-group v-if="!isTabelle" v-model="isFreilos" row>
                <v-radio :label="this.label?.singular" :value="false"/>
                <v-radio label="Freilos" :value="true"/>
            </v-radio-group>
            <div v-if="!isFreilos">
                <div class="grey--text text--darken-1 mb-3 mt-n3" style="font-size: 13px">
                    Bitte gib die vollständige (6-stellige) Passnummer ohne Abstände ein und drücke die "Enter-Taste"
                    oder klicke auf "{{btnLabel}} suchen":
                </div>
                <v-checkbox v-model="team?.settings?.player1.noPass" label="ohne Spielerpass" class="mt-0 mb-3" hide-details/>
                <div v-if="team?.settings?.player1.noPass">
                    <v-text-field v-model="team?.settings?.player1.nachname" :rules="[rules.required]" label="Nachname" clearable/>
                    <v-text-field v-model="team?.settings?.player1.vorname" :rules="[rules.required]" label="Vorname" clearable/>
                    <v-text-field v-model="team?.settings?.player1.landesverband" :rules="[rules.required]" label="Landesverband" clearable/>
                    <v-text-field v-model="team?.settings?.player1.verein" :rules="[rules.required]" label="Verein" clearable/>
                    <v-text-field v-model="team?.settings?.player1.ak" :rules="[rules.required]" label="Altersklasse" clearable/>
                </div>
                <v-text-field v-else v-model="team?.settings?.player1.passNumber" :rules="[rules.required]" autofocus
                              label="Passnummer" clearable @keydown.enter="searchPersons()"/>
                <div v-if="isDouble">
                    <v-checkbox v-model="team?.settings?.player2.noPass" label="ohne Spielerpass (2. Person)" class="mt-0 mb-3" hide-details/>
                    <div v-if="team?.settings?.player2.noPass">
                        <v-text-field v-model="team?.settings?.player2.nachname" :rules="[rules.required]" label="Nachname (2. Person)" clearable/>
                        <v-text-field v-model="team?.settings?.player2.vorname" :rules="[rules.required]" label="Vorname (2. Person)" clearable/>
                        <v-text-field v-model="team?.settings?.player2.landesverband" :rules="[rules.required]" label="Landesverband (2. Person)" clearable/>
                        <v-text-field v-model="team?.settings?.player2.verein" :rules="[rules.required]" label="Verein (2. Person)" clearable/>
                        <v-text-field v-model="team?.settings?.player2.ak" :rules="[rules.required]" label="Altersklasse (2. Person)" clearable/>
                    </div>
                    <v-text-field v-else v-model="team?.settings?.player2.passNumber" :rules="[rules.required]"
                                   label="Passnummer 2. Person" clearable @keydown.enter="searchPersons()"/>
                </div>
                <v-btn v-if="!team?.settings?.player1.noPass || (!team?.settings?.player2?.noPass && isDouble)"
                       @click="searchPersons" :disabled="searchDisabled" color="primary" class="mb-4" >
                    <v-icon>mdi-magnify</v-icon>
                    {{ btnLabel }} suchen
                </v-btn>
                <meisterschaft-team-edit-card v-if="!team?.settings?.player1.noPass"
                                              :searchError="searchError.player1" :rules="rules" player-key="player1"
                                              :player="team?.settings?.player1" :is-searching="isSearching.player1"
                                              @playerSelected="setPersonAndBindLV"/>
                <meisterschaft-team-edit-card v-if="isDouble && !team?.settings?.player2?.noPass"
                                              :searchError="searchError.player2" :rules="rules" player-key="player2"
                                              :player="team?.settings?.player2" :is-searching="isSearching.player2"
                                              @playerSelected="setPersonAndBindLV" />
            </div>
            <v-alert v-if="error" color="error" text icon="mdi-alert" class="mt-3" style="font-size: 14px">{{error}}</v-alert>
        </div>
    </form-container>
</template>

<script>
    import FormContainer from "@/components/form/formContainer.vue";
    import {FormRules} from "@/services/formRules";
    import {BewerbTeamSingle} from "@/services/data/meisterschaften/bewerbTeamSingle";
    import {BewerbTeamDouble} from "@/services/data/meisterschaften/bewerbTeamDouble";
    import FirebaseRead from "@/services/database/firebaseRead";
    import SPIELER_MEMBERSHIP_HANDLER from "@/services/data/spieler/spielerMembershipHandler";
    import MeisterschaftTeamEditCard from "@/views/ergebnisdienst/meisterschaft/teams/meisterschaftTeamEditCard.vue";

    export default {
        components: {MeisterschaftTeamEditCard, FormContainer},
        name: "meisterschaft-team-edit",
        props: ['currentData', 'currentRunde', 'currentSpiel', 'bewerb', 'spielTyp'],
        data: () => ({
            rules: null,
            team: null,
            error: '',
            isSearching: {player1: false, player2: false},
            searchError: {player1: null, player2: null},
            isFreilos: false
        }),
        computed: {
            bewerbTyp(){ return this.$route.query.bewerbTyp },
            isTabelle(){ return this.currentRunde?.settings?.modus === 'tabelle' },
            label(){ return this.bewerb?.getTeamLabel() },
            isDouble(){ return this.spielTyp === 'doppel'},
            btnLabel(){ return this.isDouble? "Personen" : "Person" },
            freilosTitle(){ return this.isTabelle ? this.currentData?.id ? ' ändern' : ' hinzufügen' :
                                                    this.currentData?.id ? '/Freilos ändern' : '/Freilos hinzufügen'},
            title(){ return this.label?.singular + this.freilosTitle},
            editTeamParam(){ return this.$route.query.action === 'editMeisterschaftTeam' },
            searchDisabled(){ return this.isDouble ?
                (this.team?.settings?.player1?.passNumber?.length !== 6 && !this.team?.settings?.player1?.noPass) ||
                (this.team?.settings?.player2?.passNumber?.length !== 6 && !this.team?.settings?.player2?.noPass) :
                this.team?.settings?.player1?.passNumber?.length !== 6 && !this.team?.settings?.player1?.noPass
            },
            player1PassNumber(){ return this.team?.settings?.player1?.passNumber },
            player2PassNumber(){ return this.team?.settings?.player2?.passNumber },
        },
        created(){
            this.rules = new FormRules();
        },
        methods: {
            init(){
                const id = this.currentData?.id??null
                this.searchError = {player1: null, player2: null}
                this.isSearching = {player1: false, player2: false}
                this.isFreilos = this.currentSpiel?.spielData?.[this.currentSpiel?.teamKey+'Freilos']??false
                this.team = !this.isDouble ? new BewerbTeamSingle(
                                    this.currentData, id, this.currentSpiel?.teamKey) :
                                 new BewerbTeamDouble(this.currentData, id, this.currentSpiel?.teamKey)
            },
            searchPersons(){
                this.error = ''
                if ( !this.team?.settings?.player1.noPass ) this.searchPerson('player1')
                if ( this.isDouble && !this.team?.settings?.player2.noPass ) this.searchPerson('player2')
            },
            async searchPerson(player){
                if ( !this.searchDisabled ) {
                    this.searchError[player] = ''
                    const passNumber = this.team.settings[player]?.passNumber
                    const personenFound = await FirebaseRead.readDocList('spieler',
                        {field: 'search.passNumbers.' + passNumber, operator: '==', value: true })
                // check if only one person found
                    if ( personenFound.length === 0) {
                        this.searchError[player] = {code: 'notFound', msg: 'Es wurde keine Person mit dieser Passnummer gefunden.'}
                        this.team.settings[player] = this.team.getEmptyPlayer(passNumber)
                        return
                    } else if ( personenFound.length > 1) {
                        this.searchError[player]= {code: 'tooMany', msg: 'Es wurde mehr als eine Person mit dieser ' +
                                'Passnummer gefunden. Bitte wähle eine der Personen oder gib die Daten manuell ein.',
                                                    data: personenFound}
                        this.team.settings[player] = this.team.getEmptyPlayer(passNumber)
                        return
                    }
                // set person and bindLv if needed
                    this.setPersonAndBindLV({player, person:personenFound[0]})
                }
            },
            setPersonAndBindLV(params){
                const {player, person} = params
                this.searchError[player] = ''
                const passNumber = this.team?.settings[player]?.passNumber
                const lvId = passNumber.substring(0, 2)
                const lvShort = this.$store.state.local.landesverbaende.find(lv => lv.id === lvId)?.abbreviation
                const vereinId = SPIELER_MEMBERSHIP_HANDLER.getLastRegularMembership(person.memberships).lvVereinId.substring(2)
                this.bindLv(lvId)
                this.setPlayer(player, person, passNumber, lvShort, lvId, vereinId, 0)
            },
            setPlayer(player, person, passNumber, lvShort, lvId, vereinId, tries){
                this.isSearching[player] = true
                const vereinName = this.$store.state.realtime.landesverbaende[lvId]?.vereine[vereinId]?.name
                if ( vereinName ) {
                    this.team.setPlayer(player, person, passNumber, lvShort, vereinName, this.bewerb.id)
                    this.isSearching[player] = false
                } else if ( tries < 10 )   {
                    tries++
                    setTimeout(() => {
                        this.setPlayer(player, person, passNumber, lvShort, lvId, vereinId)
                    }, 500)
                } else {
                    this.isSearching[player] = false
                }
            },
            bindLv(lvId){
                if ( this.$store.state.realtime.landesverbaende[lvId] ) return
                this.$store.dispatch('bindRealtimeDocument', {
                    collection: 'landesverbaende', docId: lvId, storeField: 'landesverbaende.' + lvId,
                });
            },
            async save(){
                if ( !this.isFreilos ) {
                // check for completness
                    this.error = this.team.settingsComplete()
                    if ( this.error ) return
                // check for duplicate player pro Runde
                    this.error = this.currentRunde.checkForDuplicatePlayers(this.team, this.isDouble,
                        this.currentSpiel?.spielData.id, this.currentSpiel?.teamKey)
                    if ( this.error ) return
                // uppercase last name
                    this.team.settings.player1.nachname = this.team.settings.player1.nachname.toUpperCase()
                    if ( this.isDouble ) this.team.settings.player2.nachname = this.team.settings.player2.nachname.toUpperCase()
                // fill settings from player
                    this.team.fillSettingsFromPlayer()
                }
            // save
                this.$store.state.local.loader = true;
                const reply = this.currentSpiel?.teamKey?
                    await this.team.updateTeamInKoRunde(this.bewerb.id, this.currentRunde,
                                                        this.currentSpiel, this.isFreilos) :
                    await this.team.updateTeamInRunde(this.bewerb.id, this.currentRunde.id)
                reply.successful ? this.handleSuccess(reply) : this.error = reply.content
                this.$store.state.local.loader = false;
            },
            handleSuccess(reply){
                console.log ("reply", reply);
                if ( this.currentSpiel?.teamKey ) {
                    this.bewerb.runden[this.currentRunde.id].spiele[this.currentSpiel.spielData.id] = reply.spiel
                } else {
                    if(!this.team.id) this.team.id = reply.content.id
                    this.bewerb.runden[this.currentRunde.id].updateTeamList(this.team)
                }
                this.team = null
                this.isFreilos = false
                window.history.back();
            },
            clearPlayerExceptPassnumber(to, from, player){
                this.error = ''
                if ( to && from && this.team.settings[player].nachname ) {
                    this.team.clearPlayerExceptPassnumber(player)
                }
                this.searchError[player] = null
            }
        },
        watch: {
            editTeamParam(to){ if ( to ) this.init() },
            player1PassNumber(to, from) { this.clearPlayerExceptPassnumber(to, from, 'player1') },
            player2PassNumber(to, from) { this.clearPlayerExceptPassnumber(to, from, 'player2') },
        }
    }
</script>

<style scoped>

</style>